import type { AlertStatusName } from './generated/gql-enums';

export const ALERT_STATUS_ACTIVE = 'active' satisfies AlertStatusName;
export const ALERT_STATUS_BACKLOGGED = 'backlogged' satisfies AlertStatusName;
export const ALERT_STATUS_REMOVED = 'removed' satisfies AlertStatusName;
